import * as React from "react";
const SvgFiRrTotal = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M22 20c0 2.206-1.794 4-4 4H4.394a2.35 2.35 0 0 1-2.19-1.481 2.35 2.35 0 0 1 .558-2.587L11.055 12 2.761 4.068a2.35 2.35 0 0 1-.559-2.586A2.35 2.35 0 0 1 4.393 0H18c2.206 0 4 1.794 4 4a1 1 0 1 1-2 0c0-1.103-.897-2-2-2H4.394a.34.34 0 0 0-.336.227.35.35 0 0 0 .086.396l9.048 8.654a1 1 0 0 1 0 1.446l-9.048 8.654a.35.35 0 0 0-.086.396.345.345 0 0 0 .336.227H18c1.103 0 2-.897 2-2a1 1 0 1 1 2 0"
    />
  </svg>
);
export default SvgFiRrTotal;
